import React from "react";
import PropTypes from "prop-types";
import Carousel from "@brainhubeu/react-carousel";

import RechargeValue from "../RechargeValue/RechargeValue";

import "@brainhubeu/react-carousel/lib/style.css";
import Title from "../../Titles/Title/Title";
import HorizontalScroll from "../../../shared/HorizontalScroll/HorizontalScroll";

import List from "../List/List";

const RechargeValueList = ({ rechargeValues, onClick, media }) => {
  const rechargeValuesList = rechargeValues.map(rechargeValue => (
    <RechargeValue key={rechargeValue.id} rechargeValue={rechargeValue} onClick={onClick} />
  ));

  return (
    <List paddingTop={48} paddingLeft={0} paddingBottom={0} paddingRight={0}>
      <Title
        marginLeft={media.mobile || media.tablet ? "8%" : "18%"}
        marginBottom={media.mobile || media.tablet ? "8%" : "8%"}
      >
        <h1>Claro Recarga Móvel</h1>
      </Title>
      {media.mobile || media.tablet ? (
        <HorizontalScroll>{rechargeValuesList}</HorizontalScroll>
      ) : (
        <Carousel itemWidth={280} arrows infinite>
          {rechargeValuesList}
        </Carousel>
      )}
    </List>
  );
};

RechargeValueList.propTypes = {
  rechargeValues: PropTypes.array,
  onClick: PropTypes.func.isRequired,
  media: PropTypes.object.isRequired,
};

RechargeValueList.defaultProps = {
  rechargeValues: [],
};

export default RechargeValueList;
